export default "__VITE_ASSET__BKGLSgnf__"